<template>
    <div class="offer-site">
        <div class="offer-pdf__no-print row">
            <div class="col-4">
                <div class="m-portlet">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <h3 class="m-portlet__head-text">
                                    Anfrage
                                </h3>
                            </div>
                        </div>
                    </div>

                    <!--begin::Form-->
                    <form class="m-form m-form--fit m-form--label-align-right">
                        <div class="m-portlet__body">
                            <div class="row mb-4">
                                <div class="offset-3 col-9">

                                    <div class="m-card-user m-card-user--sm" v-if="offer.client">
                                        <div class="m-card-user__pic">
                                            <div class="m-card-user__no-photo m--bg-fill-success" :class="'m-badge--client-class-1'"><span>{{ offer.client.class }}</span></div>
                                        </div>
                                        <div class="m-card-user__details">
                                            <span class="m-card-user__name m--font-primary" v-if="offer.client.company != ''" style="max-width:350px;">{{ offer.client.company }}</span>
                                            <span class="m-card-user__name" style="max-width:350px;">{{ offer.client.user.salutation }} {{ offer.client.user.pre_name }} {{ offer.client.user.name }}</span>
                                            <span class="m-card-user__name" style="max-width:350px;"><small><i class="fa fa-at"></i> {{ offer.client.user.email }}</small></span>
                                            <span class="m-card-user__name" v-if="offer.client.phone != ''" style="white-space: nowrap"><small><i class="fa fa-phone"></i> {{ offer.client.phone }}</small></span>
                                            <span class="m-card-user__name"><a class="mt-4 btn btn-sm btn-brand" :href="'/kunde-' + offer.client.id" target="_blank">Zum Kunden</a></span>
                                        </div>
                                    </div>
                                    <div class="m-card-user m-card-user--sm" v-else>
                                        <div class="m-card-user__pic">
                                            <div class="m-card-user__no-photo m--bg-fill-success" :class="'m-badge--client-class-' + offer.classId"><span>{{ offer.className }}</span></div>
                                        </div>
                                        <div class="m-card-user__details">
                                            <span class="m-card-user__name m--font-primary" v-if="offer.firma != ''" style="max-width:350px;">{{ offer.firma }}</span>
                                            <span class="m-card-user__name" style="max-width:350px;">{{ offer.salutation }} {{ offer.pre_name }} {{ offer.name }}</span>
                                            <span class="m-card-user__name" style="max-width:350px;"><small><i class="fa fa-at"></i> {{ offer.email }}</small></span>
                                            <span class="m-card-user__name" v-if="offer.telefon != ''" style="white-space: nowrap"><small><i class="fa fa-phone"></i> {{ offer.telefon }}</small></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-3 text-right">Produkttyp</div>
                                <div class="col-9">{{offer.produkttyp}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-3 text-right">Produkt</div>
                                <div class="col-9">{{offer.produkt}}</div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-3 text-right">Anfrage</div>
                                <div class="col-9">{{offer.anfrage}}</div>
                            </div>
                            <div class="row">
                                <label class="col-3 text-right">Projekttyp</label>
                                <div class="col-9" v-for="(type, key) in projectTypeArr" v-if="key == offerTemplate.project_type_id">{{ type }}</div>
                            </div>
                            <div class="row">
                                <label class="col-3 text-right">Projekt Vorlage</label>
                                <div class="col-9">{{ offerTemplate.name }}</div>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="m-portlet mt-4">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <h3 class="m-portlet__head-text">
                                    Auslastung & Mitarbeiter
                                </h3>
                            </div>
                        </div>
                    </div>
                    <!--begin::Form-->
                    <div class="m-portlet__body">
                        <div class="row">
                            <div class="col-6 border-right">
                                <div v-for="employee in employeeWorkload" class="row mb-3" v-if="employee.workload > 0">
                                    <div class="col-3 d-flex align-items-center">{{ employee.name }}</div>
                                    <div class="col-2 d-flex align-items-center">{{ employee.workload }}h</div>
                                    <div class="col-5 d-flex align-items-center">
                                        <el-progress :color="customColors" :show-text="false" :percentage="employee.workloadPer" class="w-100"></el-progress>
                                    </div>
                                    <div class="col-2 d-flex align-items-center">80h</div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div v-for="workload in kwWorkload" class="row mb-3" v-if="workload.workload > 0">
                                    <div class="col-3 d-flex align-items-center">KW {{ workload.name }}</div>
                                    <div class="col-2 d-flex align-items-center">{{ workload.workload }}h</div>
                                    <div class="col-5 d-flex align-items-center">
                                        <el-progress :color="customColors" :show-text="false" :percentage="workload.workloadPer" class="w-100"></el-progress>
                                    </div>
                                    <div class="col-2 d-flex align-items-center">120h</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-4">
                <div class="m-portlet">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <h3 class="m-portlet__head-text">
                                    Kunde anlegen
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body" v-if="offer.client">

                    </div>
                    <div class="m-portlet__body" v-else>
                        <client :offer="offer"></client>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="offer-pdf__container" v-html="offer.offer_template_html"></div>
                <div class="offer-pdf__print text-center mt-4">
                    <el-button @click="triggerPrint()" type="success" :disabled="projectType === null || offerTemplate.name === null">PDF drucken</el-button>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

import OfferAPI from "~/api/offer";

import OfferPdf from "./offer/OfferPdf";
import Client from "./offer/Client";

export default {

    components: {
        OfferPdf,
        Client,
    },
    props: {
        offerData: Object,
        midAmount: Number,
        reminderTypeArr: Array,
        employeeArr: Object,
        projectAmountArr: Object,
        projectTypeArr: Array,
        offerTemplates: Array,
        employeeWorkload: Object,
        categoriesArr: Object,
        user: Object,
        upsellingData: Object,
        kwWorkload: Object,
        kwPlanning: Object
    },
    data() {
        return {
            saveDone: false,
            printDone: false,
            offer: null,
            openOfferData: false,
            offerTemplate:{
                name: null,
                difficulty: null,
                service_price: 0.5,
                image_per_hour: 5,
                init_time_min: 60,
                project_type_id: null,
                templateParts: [],
            },
            customColors: [
                {color: '#5cb87a', percentage: 20},
                {color: '#5cb87a', percentage: 50},
                {color: '#e6a23c', percentage: 60},
                {color: '#f56c6c', percentage: 90},
                {color: '#f56c6c', percentage: 100}
            ],
            projectType: null,
            selectedCompany: "Produktfotografie-24h.de",
            manager: null,
            companys:[
                "Produktfotografie-24h.de",
                "Clipping-Agency.com",
                "capture-studio.de"
            ],
            saveButtonDisabled: true
        }
    },
    created() {
        this.offer = this.offerData;
        this.upselling = this.upsellingData;

        if (this.offer.country == ""){
            this.offer.country = "Deutschland";
        }


        this.manager = this.employeeArr[this.user.id];
        this.projectAmountId = this.offer.approxmate_amout;
        this.amount = (this.offer.exact_amount > 0) ? this.offer.exact_amount : this.midAmount;
        this.getSum();

        if (this.offer.client){
            this.lastname = this.offer.client.name;
        }
        else{
            this.lastname = this.offer.name;
        }

        if (this.offer.category_id > 0){
            this.projectType = this.offer.category_id;
        }

        if (this.offer.offer_template_id > 0){
            let them = this;

            this.offerTemplates.filter(function(el) {
                if (parseInt(el.id) === parseInt(them.offer.offer_template_id)){
                    them.offerTemplate = el;
                }
            });
        }


    },
    computed: {
        missingOfferData(){
            if (this.offer.salutation == "" || this.offer.pre_name == "" || this.offer.name == "" || this.offer.telefon == "" || this.offer.street == "" || this.offer.city == "" || this.offer.zip == ""){
                return true;
            }
            else{
                return false;
            }
        },
        projectTemplates(){
            let them = this;
            let tmp = [];
            this.offerTemplates.filter(function(el) {
                if (parseInt(el.project_type_id) === parseInt(them.projectType)){
                    tmp.push(el);
                }
            });

            return tmp;
        }
    },
    methods: {
        triggerPrint(){
            window.print();
            this.printDone = true;
        },
        getSum(){
            let price = Math.floor((this.offerTemplate.init_time_min / this.amount) + (this.hourly / this.offerTemplate.image_per_hour) + parseFloat(this.offerTemplate.service_price));
            this.sum = price * this.amount;
            let tmp = this.sum - this.costs
            this.profit = tmp.toFixed(2);
        },
        setOfferTemplate(offerTemplateVar){
            this.offerTemplate = offerTemplateVar;
            this.getSum();
        },
        saveOfferData(){
            let that = this;

            OfferAPI.postUpdateOffer({
                offer: that.offer,
            }).then(function (response) {
                location.reload()
            });
        },
    }

}
</script>
